var app = angular.module("leonardo");

var ReportsActivityList = function($scope, $controller, $state, $filter, ReportService, FilterService) {

  $controller('ReportsBaseController', { $scope: $scope });

  $scope.title = $filter('translate')('Activity Reports');
  $scope.report_type = ReportService.TYPE_ACTIVITY;

  if ($state.$current.includes['administrative-reports']) {
    $scope.fieldsReport = ReportService.fieldsReportActivityAdmin;
  }
  else {
    $scope.fieldsReport = ReportService.fieldsReportActivity;
  }

  $scope.resetFields = function() {
    if (FilterService.hasFilter('fields_active')) {
      $scope.fields_active = FilterService.getFilter('fields_active').split(',');
    }
    else {
      $scope.fields_active = ['account', 'portfolios', 'properties', 'name', 'email', 'user_role', 'dates_active',
        'num_days_activity', 'days_since_last_activity', 'last_activity', 'last_action', 'users_report_to'];
    }
  };

  $scope.getDaysSince = function(date){
    return moment(date).fromNow();
  };

  $scope.getFieldClasses = function (field) {
    var classes = [];
    if (field == 'dates_not_logged') {
      classes.push('date-multi-head');
    }
    return classes;
  };

  $scope.getFieldValue = function(report, field) {
    var html = '';
    switch(field) {
      case 'name':
        return $filter('username')(report.user);
      case 'email':
        return report.user ? report.user.email : '';
      case 'account':
        return report.account.name;
      case 'portfolio':
      case 'property':
      case 'group':
        if (report.last_activity && report.last_activity[field]) {
          return report.last_activity[field].name;
        }
        else {
          return '-';
        }
      case 'portfolios':
      case 'properties':
      case 'groups':
        html = '<div class="wrapper-date-multi" read-more>';
        if (report[field] && angular.isArray(report[field])) {
          angular.forEach(report[field], function(item){
            html += '<span class="date-multi">' + item + '</span>';
          });
        }
        else if (report[field]) {
          html += '<span class="date-multi">' + report[field].name + '</span>';
        }
        html += '</div>';
        return html;
      case 'user_role':
        return report.role  ? report.role.name : '-';
      case 'date_joined':
        return moment(report.date_joined).format('MMM DD, YYYY');
      case 'dates_active':
        html = '<div class="wrapper-date-multi" read-more>';
        if (report.dates_active) {
          angular.forEach(report.dates_active, function(date){
            html += '<span class="date-multi">' + moment(date).format('MMM DD, YYYY') + '</span>';
          });
        }
        html += '</div>';
        return html;
      case 'num_days_activity':
        return report.num_days_activity || 0;
      case 'days_since_last_activity':
        if (report.last_activity) {
          return $scope.getDaysSince(report.last_activity.datetime_done);
        }
        else {
          if (report.has_any_activity) {
            return 'Not active';
          }
          else {
            return 'Never';
          }
        }
      case 'last_activity':
        if (report.last_activity){
          var dateArray = report.last_activity.datetime_done ?
            report.last_activity.datetime_done.split('T') : [report.last_activity.datetime_done];
          return moment(dateArray[0]).format('MMM DD, YYYY');
        }
        else
          if (report.has_any_activity) {
            return 'Not active';
          }
          else {
            return 'Never';
          }
      case 'last_action':
        if (report.last_activity) {
          return report.last_activity.action_done;
        }
        else {
          if (report.has_any_activity) {
            return 'Not active';
          }
          else {
            return 'Never';
          }
        }
      case 'users_report_to':
        if (report.report_to && report.report_to.user) {
          return $filter('username')(report.report_to.user);
        }
        else {
          return '';
        }
      case 'users_report_to_email':
        if (report.report_to && report.report_to.user) {
          return report.report_to.user.email;
        }
        else {
          return '';
        }
      case 'managed_by':
        html = '';
        if (angular.isArray(report.managed_by)) {
          angular.forEach(report.managed_by, function(manager){
            html += '<span>' + manager.name +'</span>';
          });
        }
        else {
          html = report.managed_by ? report.managed_by.name : 'Only Owner';
        }
        return html;
      default: return report[field];
    }
  };

  $scope.groupReports = function(data) {
    if (data.results){
      $scope.reports = data.results ? data.results : data;
      if (data.results.info_data) {
        $scope.info_data = data.results.info_data;
      }
    }
    else {
      $scope.reports = data;
    }

    $scope.reportsGrouped = [];
    var id = 'ungroup';
    var name = 'Ungroup';
    var array_by_name = [];
    switch (FilterService.getFilter('group_by')) {
      case 'account':
        angular.forEach($scope.accounts_by_name, function (account) {
          if (getIndexArray(array_by_name, account.id) < 0) {
            array_by_name.push({id: account.id, name: account.name});
          }
        });
        break;
      case 'portfolio':
        angular.forEach($scope.portfolios_by_name, function (portfolio) {
          if (getIndexArray(array_by_name, portfolio.id) < 0) {
            array_by_name.push({id: portfolio.id, name: portfolio.name});
          }
        });
        break;
      case 'property':
        angular.forEach($scope.properties_by_name, function (property) {
          if (getIndexArray(array_by_name, property.id) < 0) {
            array_by_name.push({id: property.id, name: property.name});
          }
        });
        break;
    }
    angular.forEach($scope.reports, function(value) {
      if (value.group_by) {
        id = value.group_by.id;
        name = value.group_by.name;
      }
      switch (FilterService.getFilter('group_by')) {
        case 'group':
        case 'user_role':
          array_by_name.push({id: id, name: name});
          break;
        case 'managed_by':
          if (value.managed_by) {
            if (angular.isArray(value.managed_by)){
              id = [];
              name = [];
              array_by_name = [];
              angular.forEach(value.managed_by, function (manager) {
                id.push(manager.id);
                name.push(manager.name);
                array_by_name.push({id: manager.id, name: manager.name});
              });
            }
            else {
              id = value.managed_by.id;
              name = value.managed_by.name;
              array_by_name.push({id: value.managed_by.id, name: value.managed_by.name});
            }
          }
          else {
            id = 'only_owner';
            name = 'Only Owner';
            array_by_name.push({id: id, name: name});
          }
          break;
      }
      if (angular.isArray(id)) {
        angular.forEach(array_by_name, function (value_manager) {
          if ($scope.getIndex(value_manager.id) < 0) {
            $scope.reportsGrouped.push({id: value_manager.id, name: value_manager.name, reports: []});
          }
          if ($scope.getIndexUserArray($scope.reportsGrouped[$scope.getIndex(value_manager.id)].reports, value.id) === -1) {
            $scope.reportsGrouped[$scope.getIndex(value_manager.id)].reports.push(value);
          }
        });
      }
      else {
        if ($scope.getIndex(id) < 0) {
          $scope.reportsGrouped.push({id: id, name: name, reports: []});
        }
        if ($scope.getIndexUserArray($scope.reportsGrouped[$scope.getIndex(id)].reports, value.id) === -1) {
          $scope.reportsGrouped[$scope.getIndex(id)].reports.push(value);
        }
      }
    });

    if ($scope.reportsGrouped.length === 1) {
      $scope.groupExpanded = $scope.reportsGrouped[0].id;
    }
    else {
      $scope.reportsGrouped = $filter('orderBy')($scope.reportsGrouped, 'name');
    }
  };

  if (!ReportService.getQuickReport() && FilterService.hasFilter('mia')) {
    $scope.initReport();
  }

};

app.controller('ReportsActivityList', ['$scope', '$controller', '$state', '$filter', 'ReportService', 'FilterService',
  ReportsActivityList]);
